export const name = '$gzSignin';
export default function $gzSignin(
  rnApplication,
  $window
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let processingSignIn = false;
  let processingSignOut = false;

  var vm = this;
  var service = {
    signin: signin,
    signout: signout
  };

  return service;

  ///////////////////
  // Public methods
  //////////////////

  function signin(autoForward = false) {
    if (!processingSignIn) {
      processingSignIn = true;
      rnApplication.getApplication('register').then((registerApp) => {
        let signInURL = registerApp._links.self;
        if (autoForward) {
          signInURL += '/#/signin?target=' + $window.encodeURIComponent($window.location.href);
        }
        $window.location.href = signInURL;
      })
        .finally(() => {
          processingSignIn = false;
        });
    }
  }

  function signout() {
    if (!processingSignOut) {
      rnApplication.getApplication('register').then((registerApp) => {
        let signInURL = registerApp._links.self;
        signInURL += '/#/signin?signout';
        $window.location.href = signInURL;
      })
        .finally(() => {
          processingSignIn = false;
        });
    }
  }
} //$gzSignin



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/signin/signin.service.js